<template>
  <div class="page">
    <div class="center-child">
      <svg xmlns="http://www.w3.org/2000/svg" width="569" height="172" viewBox="0 0 569 172">
        <g fill="none" fill-rule="evenodd">
          <text fill="#447EF8" font-family="Selima" font-size="150" letter-spacing="2.269">
            <tspan x="95.258" y="126">Contact</tspan>
          </text>
        </g>
      </svg>
      <p
        class="justified-big-para"
        style="color:gray;"
      >If you would like to get in touch, you can simply use this form</p>
    </div>
    <div class="center-child" id="formcontainer">
      <form action="https://formspree.io/aniket965.as@gmail.com" method="POST">
        <input class="shadow" id="name" name="name" type="text" placeholder="Name" required />
        <input class="shadow" id="email" name="_replyto" type="email" placeholder="Email" required />
        <input class="shadow" type="text" name="_gotcha" style="display:none" />
        <input class="shadow" type="hidden" name="_next" value="//aniket965.tk/" />
        <textarea
          class="shadow"
          id="message"
          name="message"
          type="text"
          placeholder="Type..."
          required
        ></textarea>
        <a type="submit" class="nostyle btn elevated-btn mfont">SEND</a>
      </form>
    </div>
    <div class="center-child">
      <p class="justified-big-para" style="color:gray;">
        <span style="color:#447EF8;font-weight:bold;">or,</span> if you dont like forms send me an email at
        <a
          href="mailto:aniket965.as@gmail.com"
          style="color:gray; text-decoration-color: #447EF8; "
        >aniket965.as@gmail.com</a>. I’ll be glad to talk.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage",
  beforeMount() {
    var metaThemeColor = document.querySelector("meta[name=theme-color]");
    metaThemeColor.setAttribute("content", "#447EF8");
  },
  methods: {
    track() {
      this.$ga.page("/contact");
    }
  }
};
</script>
<style lang="scss" scoped>
ol {
  padding-inline-start: 0px;
}

input {
  height: auto;
}

textarea {
  height: 100px;
  padding-top: 0;
  font-weight: 700;
  resize: none !important;
}

textarea,
input {
  justify-self: center;
  line-height: 1.3;
  width: 75%;
  max-width: 500px;
  color: gray;
  padding: 16px;
  background: none;
  border: none;
  font-weight: 400;
  margin-bottom: 25px;
  font-size: 13px;
  border-radius: 10px;
  text-transform: uppercase;
  font-weight: 700;
}
a {
  justify-self: center;
}
#formcontainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 2rem;
  margin-top: 2rem;
}
::-webkit-input-placeholder {
  color: gray;
  font-size: 13px;
  opacity: 1;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: gray;
  font-size: 13px;
  opacity: 1;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: gray;
  font-size: 13px;
  opacity: 1;
}

:-ms-input-placeholder {
  color: gray;
  font-size: 13px;
  opacity: 1;
}
p {
  font-family: "Satisfy", cursive;
  font-size: 2rem;
  width: 75%;
  max-width: 500px;
}
form {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
}
@media screen and (max-width: 720px) {
  svg {
    width: 90vw;
  }
  h2,
  p {
    font-size: 1.4rem;
  }
}
</style>


